import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import styles from "./Template4.module.css";

const CarouselDot = ({ active, onClick, id }) => {
  const dotClass = `carousel-dot ${active ? "carousel-dot-active" : ""}`;
  return <div className={dotClass} onClick={onClick} id={id} />;
};

export default function Template4({
  carousel,
  handleOpenForm,
  handleLinkClick,
}) {
  const [activeIndex, setActiveIndex] = useState(0);
  const cardRefs = useRef([]);
  const sliderRef = useRef(null);
  useEffect(() => {
    const slider = sliderRef.current;
    const handleScroll = () => {
      const sliderWidth = slider.offsetWidth;
      const sliderLeft = slider.getBoundingClientRect().left;
      const activeSlide = Array.from(slider.children).find((slide) => {
        const slideLeft = slide.getBoundingClientRect().left;
        return slideLeft >= sliderLeft;
      });
      setActiveIndex(
        activeSlide ? Array.from(slider.children).indexOf(activeSlide) : 0
      );
    };
    slider?.addEventListener("scroll", handleScroll);
    return () => slider?.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSlideChange = (index) => {
    setActiveIndex(index);
    if (cardRefs.current[index]) {
      cardRefs.current[index].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  };

  const handleNext = () => {
    let currentIndex = activeIndex;
    let nextIndex;
    if (currentIndex + 1 == carousel?.items?.length) {
      nextIndex = currentIndex;
    } else {
      nextIndex = currentIndex + 1;
    }
    setActiveIndex(nextIndex);
    if (cardRefs.current[nextIndex]) {
      cardRefs.current[nextIndex].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  };

  const handlePrevious = () => {
    let currentIndex = activeIndex;
    let prevIndex;
    if (currentIndex == 0) {
      prevIndex = currentIndex;
    } else {
      prevIndex = currentIndex - 1;
    }
    setActiveIndex(prevIndex);
    if (cardRefs.current[prevIndex]) {
      cardRefs.current[prevIndex].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  };
  const dots = (contestArray) =>
    contestArray.map((_, index) => (
      <CarouselDot
        key={index}
        active={index === activeIndex}
        id={`dot-${index}`}
        onClick={() => handleSlideChange(index)}
      />
    ));
  return (
    <div
      className="  py-[30px]"
      style={{ background: carousel?.bgColor, color: carousel?.textColor }}
    >
      {/* {carousel.heading && (
        <p className="text-[18px] md:text-[21px] text-white font-medium mt-[22px]">
          {carousel.heading}
        </p>
      )} */}
      <div className="w-[100%] flex flex-col items-center ">
        {carousel?.logo && <img className={styles.logo} src={carousel.logo} />}
        {carousel?.heading && (
          <p className={styles.heading} style={{ fontFamily: carousel?.font }}>
            {carousel.heading}
          </p>
        )}

        {carousel?.btnText && (
          <div
            className=" px-[24px] py-[8px] mt-[16px] rounded-[30px] font-semibold text-[12px] flex items-center justify-center  hover:cursor-pointer "
            style={{
              background: carousel?.btnColor,
              color: carousel?.btnTextColor,
            }}
            onClick={() => {
              if (carousel?.goto === "form") {
                handleOpenForm(carousel);
              } else {
                handleLinkClick(carousel);
              }
            }}
          >
            {carousel?.btnText}
          </div>
        )}
      </div>
      <div
        className={` h-[100%] flex box w-[100%] gap-[16px] pr-[16px] overflow-x-auto  
        ${
          carousel.items.length < 2
            ? "md:justify-center md:pl-[0px] pl-[16px]"
            : "pl-[16px]"
          // : "md:pl-[100px] pl-[16px]"
        }`}
        ref={sliderRef}
      >
        {carousel?.items?.map((add, index) => {
          return (
            <div
              className="md:w-[262px] w-[262px] h-[333px]  flex flex-col bg-[black]  mt-[25px] relative"
              // style={{backgroundColor: add?.bgColor}}
              onClick={() => {
                if (carousel?.goto === "form") {
                  handleOpenForm(add);
                } else {
                  handleLinkClick(add);
                }
              }}
              ref={(element) => {
                cardRefs.current[index] = element;
              }}
            >
              {add?.fileType?.startsWith("image") && (
                <img
                  src={add.fileUrl}
                  alt=""
                  className="min-w-[264px] md:w-[264px]  md:h-[100%]  w-[264px] h-[100%] object-cover "
                />
              )}
              {add.fileType?.startsWith("video") && (
                <div className="min-w-[264px] md:w-[264px] md:h-[100%] w-[264px]  h-[100%] object-cover ">
                  <ReactPlayer
                    config={{
                      file: {
                        attributes: {
                          controlsList: "nodownload",
                        },
                      },
                      youtube: { playerVars: { disablekb: 1 } },
                    }}
                    // playing={true}
                    controls={true}
                    width="100%"
                    light={add?.thumbnailUrl ? add?.thumbnailUrl : true}
                    height="100%"
                    url={add?.fileUrl}
                    className={styles.reactPlayer}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
      {carousel?.items?.length > 1 && (
        <div className="flex items-center justify-center gap-[5px] mt-[10px]">
          <button
            onClick={handlePrevious}
            // style={navigateButton}
            className=" top-[45%] z-10 left-[5px] cursor-pointer hidden md:flex w-[30px] h-[30px] rounded-full  items-center justify-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="7"
              height="11"
              viewBox="0 0 7 11"
              fill="none"
            >
              <path
                d="M6.71106 0.244134C6.33051 -0.081378 5.71346 -0.081378 5.33292 0.244134L0.570187 4.32225C-0.190306 4.97336 -0.190013 6.0285 0.570773 6.67936L5.33643 10.7559C5.71697 11.0814 6.33402 11.0814 6.71457 10.7559C7.09514 10.4303 7.09514 9.90253 6.71457 9.57699L2.63572 6.08793C2.25508 5.76242 2.25508 5.2346 2.63572 4.90909L6.71106 1.42298C7.09162 1.09747 7.09162 0.56973 6.71106 0.244134Z"
                fill={carousel?.textColor}
              />
            </svg>
          </button>
          <div className="w-fit flex items-center justify-center gap-[6px] relative z-1 h-fit">
            {dots(carousel?.items)}
          </div>

          <buttton
            onClick={handleNext}
            // style={navigateButton}
            className=" top-[45%] z-10 right-[5px] cursor-pointer hidden md:flex w-[30px] h-[30px] rounded-full  items-center justify-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="7"
              height="11"
              viewBox="0 0 7 11"
              fill="none"
            >
              <path
                d="M0.288944 10.7559C0.669493 11.0814 1.28654 11.0814 1.66708 10.7559L6.42981 6.67775C7.19031 6.02664 7.19001 4.9715 6.42923 4.32064L1.66357 0.244147C1.28303 -0.0813822 0.665985 -0.0813822 0.285426 0.244147C-0.0951421 0.569684 -0.0951421 1.09747 0.285426 1.42301L4.36428 4.91207C4.74492 5.23758 4.74492 5.7654 4.36428 6.09091L0.288944 9.57702C-0.0916245 9.90253 -0.0916245 10.4303 0.288944 10.7559Z"
                fill={carousel?.textColor}
              />
            </svg>
          </buttton>
        </div>
      )}
      {/* {carousel.items.length > 2 &&
              <div className='w-[100%] flex items-center justify-end mt-[10px]'>
                <p className='text-[14px] text-[#111111] mr-[10px] italic'>Swipe left to view more</p>
                <img src={swipe} alt="" className='h-[24px] w-[24px]' />
              </div>
            } */}
    </div>
  );
}
